import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import {
  Hotel,
  BeachAccess,
  Restaurant,
  Spa,
  Pool,
  LocalParking,
} from '@mui/icons-material';

import TerrainIcon from '@mui/icons-material/Terrain';
import GavelIcon from '@mui/icons-material/Gavel';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import CottageIcon from '@mui/icons-material/Cottage';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';


import ploatImage from '../assets/images/slider4.jpg';

const About = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const features = [
    {
      icon: <TerrainIcon  sx={{ fontSize: 50, color: 'primary.main' }} />,
      title: 'PROJECT FEATURES',
      description: '24 Plots & Bungalows (starting 2000 sq.ft) spaced in 3 Acres. Collector N.A. & Town planning sanctioned, Individual 7/12 extract.Native Bird Species of colorful variety blesses Konkan Kilbil – a Nature Lovers Paradise.',
    },
    {
      icon: <GavelIcon  sx={{ fontSize: 50, color: 'primary.main' }} />,
      title: 'Clear Title & Legal Assurance',
      description: 'All properties are 100% NA approved with proper documentation and clear titles.',
    },
    {
      icon: <HomeWorkIcon  sx={{ fontSize: 50, color: 'primary.main' }} />,
      title: 'Infrastructure',
      description: 'Electricity, Water, Internal Road, Attractive Entrance Gate, Security, Fencing etc.',
    },
    {
      icon: <DirectionsCarIcon  sx={{ fontSize: 50, color: 'primary.main' }} />,
      title: 'Easy Accessibility',
      description: 'Well-connected via road and rail — perfect for weekend getaways or permanent stays.',
    },
    {
      icon: <HomeWorkIcon  sx={{ fontSize: 50, color: 'primary.main' }} />,
      title: 'Ready for Construction',
      description: 'Immediate possession plots with access to electricity, water, and roads.',
    },
    // {
    //   icon: <CottageIcon  sx={{ fontSize: 50, color: 'primary.main' }} />,
    //   title: 'Holiday Homes Available',
    //   description: 'Choose from beautifully designed cottages ready for move-in or rental income.',
    // },
    {
      icon: <TrendingUpIcon  sx={{ fontSize: 50, color: 'primary.main' }} />,
      title: 'Great Investment Value',
      description: 'Rapidly growing destination with high future appreciation potential.',
    },
  ];

  return (
    <Box sx={{ py: 8, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        {/* Hero Section */}
        <Box sx={{ mb: 8 }}>
          <Typography
            variant="h2"
            component="h1"
            align="center"
            gutterBottom
            sx={{ fontWeight: 700, color: 'primary.main', mb: 3 }}
          >
            About Cashew County
          </Typography>
          <Typography
            variant="h5"
            align="center"
            sx={{ color: 'text.secondary', mb: 4, lineHeight: 1.6 }}
          >
            Cashew County – A Serene Escape in the Heart of Guhagar’s Coastal Beauty.
          </Typography>
        </Box>

        {/* Main Content */}
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 4, height: '100%' }}>
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                sx={{ fontWeight: 600, color: 'primary.main', mb: 3 }}
              >
                Our Story
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              At Cashew County, we bring you a serene blend of nature, comfort, and investment opportunity. Following the successful completion of KonkanKilbil NA Plots & Holiday Homes, we are proud to present our newest venture — a thoughtfully planned development of NA plots and holiday homes set amidst the lush greenery of the Konkan region.
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
              Backed by years of expertise in natural land development, we specialize in crafting eco-friendly spaces that harmonize with the environment. Our projects are developed with full legal compliance, ensuring a transparent and secure investment for our customers.

              </Typography>
              <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
              Whether you're looking to build your dream getaway home, secure a future asset, or simply reconnect with nature, Cashew County is designed to deliver lasting value, peace of mind, and a lifestyle that's both refreshing and rewarding.
              </Typography>
              {/* <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
              At Cashew County, you don’t just<strong> own a plot,</strong> you inherit a lifestyle rooted in peace, purpose, and pristine nature.
              </Typography> */}
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: '400px',
                backgroundImage: 'url('+ploatImage+')',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: 2,
                boxShadow: theme.shadows[4],
              }}
            />
          </Grid>
        </Grid>

        {/* Features Section */}
        <Box sx={{ mt: 8 }}>
          <Typography
            variant="h3"
            component="h2"
            align="center"
            gutterBottom
            sx={{ fontWeight: 700, color: 'primary.main', mb: 6 }}
          >
            Why Choose Cashew County?
          </Typography>

          <Grid container spacing={4}>
            {features.map((feature, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  elevation={2}
                  sx={{
                    height: '100%',
                    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
                    '&:hover': {
                      transform: 'translateY(-8px)',
                      boxShadow: theme.shadows[8],
                    },
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', p: 4 }}>
                    <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                    <Typography
                      variant="h6"
                      component="h3"
                      gutterBottom
                      sx={{ fontWeight: 600, color: 'primary.main' }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ lineHeight: 1.6 }}
                    >
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Mission & Vision */}
        <Box sx={{ mt: 8 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 4, height: '100%' }}>
                <Typography
                  variant="h4"
                  component="h2"
                  gutterBottom
                  sx={{ fontWeight: 600, color: 'primary.main', mb: 3 }}
                >
                  Our Mission
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                To offer thoughtfully planned NA plots and holiday homes in Guhagar that provide a seamless blend of<strong> nature, comfort, and long-term value </strong> — enabling families, investors, and nature lovers to build their dream getaways and secure a peaceful coastal lifestyle rooted in the rich heritage of Konkan.
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper elevation={3} sx={{ p: 4, height: '100%' }}>
                <Typography
                  variant="h4"
                  component="h2"
                  gutterBottom
                  sx={{ fontWeight: 600, color: 'primary.main', mb: 3 }}
                >
                  Our Vision
                </Typography>
                <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                To become <strong>Guhagar’s most trusted and nature-conscious real estate destination,</strong> where every plot and home contributes to a vibrant, sustainable, and close-knit community that celebrates serene living, responsible development, and a deep connection to the land.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default About; 